<div class="report-wrapper">
  <iframe [src]="url"></iframe>
</div>
